import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "ClientEdit",
  data: () => ({ isValid: false }),
  props: ["showEditDialog", "editedKey"],
  computed: {
    cShowEditDialog: {
      get() {
        return this.showEditDialog;
      },
      set(value) {
        if (!value) this.$emit("close");
      }
    },
    formTitle() {
      if (this.editedKey?.name) return `${this.editedKey?.name} bearbeiten`;
      else return "Neuen Key anlegen";
    }
  },
  methods: {
    async close() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie alle Änderungen verwerfen wollen?",
        confirmWarningConfig
      );
      if (isConfirmed) this.cShowEditDialog = false;
    }
  }
};
